import React from "react";
import PropTypes from "prop-types";
import DatePicker from 'react-datepicker';
import moment from 'moment';
import * as generalFunctions from "../../common/utils/generalFunctions";

export const EditDraftOrderSummary = (props) => {
  const {
    vendor,
    account,
    orderTotal,
    isSubmitButtonDisabled,
    submitButtonHandler,
    saveDraftButtonHandler,
    cancelOrderButtonHandler,
    inputChangeHandler,
    deliveryDateChangeHandler,
    orderNumber,
    orderNote,
    shipDate,
    deliveryDate,
    shipDateVisible,
    deliveryDateVisible,
    orderSummaryTitlePrefix
  } = props;

  const name = account ? (account.name ? account.name : account.accountName) : "";
  const city = account ? (account.city ? account.city : account.accountCity) : "";
  const state = account ? (account.state ? account.state : account.accountState) : "";
  const address = account ? (account.address ? account.address : account.accountAddress1) : "";
  const vendorName = vendor ? vendor.vendorName : "";
  const total = orderTotal ? orderTotal.toFixed(2) : 0;
  const panelTitle = orderSummaryTitlePrefix ? `Draft Order Summary: ${orderSummaryTitlePrefix}` : 'Draft Order Summary';
  const getDatePickerDate = (value) => {
    if (!value) {
      return null;
    }

    if (value instanceof Date) {
      return value;
    }

    const raw = value.toString();
    const datePart = raw.includes('T') ? raw.split('T')[0] : raw;

    if (moment(datePart, 'YYYY-MM-DD', true).isValid()) {
      return moment(datePart, 'YYYY-MM-DD').toDate();
    }

    if (moment(raw, ['MM/DD/YYYY', moment.ISO_8601], true).isValid()) {
      return moment(raw).toDate();
    }

    return null;
  };

  const parsedDeliveryDate = getDatePickerDate(deliveryDate);

  return (
    <div className="panel panel-default height_100percent display_inline-grid" id="orderSummary">
      <div className="panel-heading">{panelTitle}</div>
      <div className="panel-body order-summary overflow_y_auto">
        <div className="col-sm-12">
          <p className="col-sm-5">Ship To:</p>
          <div className="col-sm-7">
            <label className="col-sm-12" id="shipToName">{name}</label>
            <label className="col-sm-12" id="shipToAddress">{address}</label>
            <label className="col-sm-12" id="shipToCityState">{city}, {state}</label>
          </div>
        </div>

        <span className="col-md-12"><hr /></span>

        <div className="col-sm-12">
          <p className="col-sm-5">Ship From:</p>
          <div className="col-sm-7">
            <label className="col-sm-12" id="vendorName">{vendorName}</label>
          </div>
        </div>

        <span className="col-md-12"><hr /></span>

        {shipDateVisible &&
          <div className="col-sm-12">
            <p className="col-sm-7">Requested Ship Date:</p>
            <div className="col-sm-5">
              <label className="col-sm-12 isCurrency">{generalFunctions.getFormattedDisplayDate(shipDate)}</label>
            </div>
          </div>}

        {deliveryDateVisible &&
          <div className="col-sm-12">
            <p className="col-sm-7">Requested Arrival Date:</p>
            <div className="col-sm-5">
              <DatePicker
                id="dpDraftDeliveryDate"
                selected={parsedDeliveryDate}
                onChange={deliveryDateChangeHandler}
                className="form-control textbox"
                dateFormat="MM/dd/yyyy" />
            </div>
          </div>}

        <div className="col-sm-12">
          <p className="col-sm-7">Order Total:</p>
          <div className="col-sm-5">
            <label className="col-sm-12 isCurrency">{parseInt(total) === 0 ? 'MKT' : `$${total}`}</label>
          </div>
        </div>

        <span className="col-md-12"><hr /></span>

        <div className="col-sm-12">
          <input type="text"
            id="orderNumber"
            className="form-control textbox"
            value={orderNumber || ''}
            placeholder="Purchase Order Number"
            onChange={(e) => inputChangeHandler(e)} />
        </div>

        <div className="col-sm-12">
          <textarea rows="3"
            id="orderNote"
            className="form-control textbox"
            value={orderNote || ''}
            placeholder="Special instructions or notes to distributor"
            onChange={(e) => inputChangeHandler(e)}
            maxLength="250" />
        </div>

        <div className="col-sm-12">
          <p className="col-sm-12">250 characters max</p>
        </div>

        <div className="pull-right">
          <button id="saveDraftOrder" className="btn btn-primary" style={{ marginLeft: '10px'}} disabled={isSubmitButtonDisabled} onClick={() => saveDraftButtonHandler()}>
            Save Draft Order
          </button>
        </div>

        <div className="pull-right">
          <button id="submitOrder" className="btn btn-primary" disabled={isSubmitButtonDisabled} onClick={() => submitButtonHandler()}>
            Approve and Submit
          </button>
        </div>

        <div className="pull-right" style={{ clear: 'both', marginTop: '10px' }}>
          <button id="cancelOrder" className="btn btn-danger" onClick={() => cancelOrderButtonHandler()}>
            Cancel Order
          </button>
        </div>
      </div>
    </div>
  );
};

EditDraftOrderSummary.propTypes = {
  vendor: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired,
  orderTotal: PropTypes.number.isRequired,
  orderNumber: PropTypes.string,
  orderNote: PropTypes.string,
  shipDate: PropTypes.string,
  deliveryDate: PropTypes.string.isRequired,
  shipDateVisible: PropTypes.bool.isRequired,
  deliveryDateVisible: PropTypes.bool.isRequired,
  orderSummaryTitlePrefix: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isSubmitButtonDisabled: PropTypes.bool.isRequired,
  submitButtonHandler: PropTypes.func.isRequired,
  saveDraftButtonHandler: PropTypes.func,
  cancelOrderButtonHandler: PropTypes.func.isRequired,
  deliveryDateChangeHandler: PropTypes.func,
  inputChangeHandler: PropTypes.func.isRequired
};
